import React, { useState } from "react";

import CopyToClipboard from "react-copy-to-clipboard";
import PillButton from "components/general/PillButton";
import Player from "components/player/Player";
import { embedDomain } from "environment";
import iconCheck from "images/ic_check.png";
import iconCopy from "images/ic_copy_black.png";
import styled from "styled-components";
import theme from "styles/theme";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing.unit * 2}px;

  color: ${theme.colors.black};
`;

const Title = styled.div`
  font-family: "Degular";
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 120%;
`;

const PlayerContainer = styled.div`
  pointer-events: none;
`;

const Legal = styled.div`
  padding: ${theme.spacing.unit * 1}px 0;

  font-family: "Degular";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 122%;
  color: ${theme.colors.gray3};

  a {
    text-decoration: underline;
  }
`;

const CodeContainer = styled.div`
  border: 2px solid ${theme.colors.gray1};
  border-radius: 16px;
  padding: ${theme.spacing.unit * 2}px;

  word-break: break-all;

  font-family: "Degular";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  color: #909195;
`;

const CopyButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const CopyButton = styled(PillButton)``;

const EmbedPrompt = ({ className, jobClip, jobClipTrackPermalink }) => {
  const [isCopied, setIsCopied] = useState(false);

  const jobClipCopy = JSON.parse(JSON.stringify(jobClip));
  if (jobClipTrackPermalink) {
    jobClipCopy.jobClipTracks = jobClipCopy.jobClipTracks.filter(
      (track) => track.permalink === jobClipTrackPermalink
    );
  }

  const code = `<div data-puck-audio-id="${jobClip.permalink}"${
    jobClipTrackPermalink
      ? ` data-puck-audio-track-id="${jobClipTrackPermalink}"`
      : ""
  }></div><script>function loadPuckEmbed(e){if(window.Puck){window.Puck.loadPlayers();return}{let t=!1,l=document.getElementsByTagName("script");for(let c=0;c<l.length;c++)l[c].getAttribute("src")===e&&(t=!0);if(!t){let a=document.createElement("script");a.onload=()=>window.Puck.loadPlayers(),a.src=e,a.async=!0,document.head.appendChild(a)}}}loadPuckEmbed("https://${embedDomain}/player.js");</script>`;

  const handleCodeCopied = () => {
    setIsCopied(true);
  };

  return (
    <Container className={className}>
      <Title>Embed clip</Title>
      <PlayerContainer>
        <Player jobClip={jobClipCopy} analyticsSrc={"Embed Prompt"} />
      </PlayerContainer>
      <Legal>
        By embedding a player on your site, you are agreeing to Puck's{" "}
        <a
          href="https://www.careerpuck.com/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms
        </a>{" "}
        and{" "}
        <a
          href="https://www.careerpuck.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy
        </a>
      </Legal>
      <CodeContainer>{code}</CodeContainer>
      <CopyButtonContainer>
        <CopyToClipboard text={code} onCopy={handleCodeCopied}>
          {isCopied ? (
            <CopyButton
              isLarge
              isBrandedPrimary
              brandingData={jobClip.employerProfile.brandingData}
              icon={iconCheck}
              defaultWidth={148}
            >
              Copied
            </CopyButton>
          ) : (
            <CopyButton isLarge isPrimary icon={iconCopy} defaultWidth={148}>
              Copy
            </CopyButton>
          )}
        </CopyToClipboard>
      </CopyButtonContainer>
    </Container>
  );
};

export default EmbedPrompt;
